import { render } from "./CardContacts.vue?vue&type=template&id=78c20240&scoped=true"
import script from "./CardContacts.vue?vue&type=script&lang=js"
export * from "./CardContacts.vue?vue&type=script&lang=js"

import "./CardContacts.vue?vue&type=style&index=0&id=78c20240&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/uparte_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c20240"]])

export default __exports__